import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DOM from './userCreate';

import * as UserActions from '../../core/user/userActions';
import * as DriverActions from '../../core/driver/driverActions';

class UserCreate extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
    }

    componentDidMount() {
        const { actions } = this.props;

        actions.resetNewUserPictureRequest();
        actions.getGeneralDataRequest();
    }

    render() {
        return this.view();
    }
}

UserCreate.propTypes = {
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...UserActions,
                ...DriverActions,
            },
            dispatch,
        ),
    };
}
export const UserCreateTest = UserCreate;
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UserCreate);
